import {classes} from '@bitstillery/common/lib/utils'
import {FieldSwitch} from '@bitstillery/common/components'
import {MithrilComponent} from '@bitstillery/mithril'
import {is_filter_activated, unset_filter_selection} from '@bitstillery/common/lib/filters'
import {$t} from '@bitstillery/common/app'
import m from '@bitstillery/mithril'

import type {FilterToggleState, FilterI18nResolved} from '@bitstillery/common/types'

interface FilterToggleAttrs {
    className: string
    filter: FilterToggleState
    filter_count?: boolean
    title?: string
    translate?: FilterI18nResolved | undefined
}

export class FilterToggle extends MithrilComponent<FilterToggleAttrs> {
    view(vnode: m.Vnode<FilterToggleAttrs>) {
        return (
            <FieldSwitch
                className={classes('c-filter-toggle', 'filter', vnode.attrs.className, {
                    active: is_filter_activated(vnode.attrs.filter),
                })}
                help={vnode.attrs.filter.help}
                label={$t(vnode.attrs.filter.title)}
                model={vnode.attrs.filter.$selection}
                props={{off: unset_filter_selection(vnode.attrs.filter), on: true}}
            />
        )
    }
}
